import { Injectable } from '@angular/core';
import { BASE_URL, errorHandler } from '../util/http.service';
import { httpOptions } from '../util/http.util';
import { APIKeyType } from '../models/api-key';
import { dict, string } from 'decoders';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../core/services/api/auth.service';
import { catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { EventsService, EventsServiceManager } from '../util/events.service';

const apiKeyTypeMapDecoder = dict(string).transform((raw) => {
  return Object.entries(raw).map((e) => {
    return { id: e[0], name: e[1] };
  });
});

@Injectable({
  providedIn: 'root',
})
export class ApiKeyTypesService {
  private errorsService: EventsService<Error>;

  constructor(
    private router: Router,
    private http: HttpClient,
    private authService: AuthService,
    private eventsServiceManager: EventsServiceManager
  ) {
    this.errorsService = this.eventsServiceManager.get(
      'content.errors',
      new Error()
    );
  }

  getAll(): Observable<APIKeyType[]> {
    const decoder = apiKeyTypeMapDecoder;
    const url = `${BASE_URL}/api_key_types`;
    return this.http.get(url, httpOptions()).pipe(
      map((response) => decoder.verify(response['data'])),
      catchError(
        errorHandler(this.router, this.authService, this.errorsService)
      )
    );
  }
}
